/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "dfsart-dev",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "dfs50925-dev",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:8d0aa291-6cbf-4055-ba93-926b294aaa01",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_VHPZLh4KF",
    "aws_user_pools_web_client_id": "4kr40jgtr3p5jg2462uv6n7b9p",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "dfsapi",
            "endpoint": "https://r1qmu48w6g.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
